import Navbar from '@/components/Navbar'

import Container from '@/components/onlineBooking/Container'
import Menu from '@/components/onlineBooking/Menu'
import OnlineBookingSettings from '@/components/onlineBooking/OnlineBookingSettings'
import AdvancedSettings from '@/components/onlineBooking/AdvancedSettings'
import TrackersSettings from '@/components/onlineBooking/TrackersSettings'

export default [
  {
    path: '/online-booking',
    name: 'OnlineBooking',
    meta: {
      title: 'navbar.online_booking'
    },
    components: {
      default: Container,
      navbar: Navbar,
      menu: Menu
    },
    children: [
      {
        path: 'settings',
        component: OnlineBookingSettings,
        meta: {
          requiresAuth: true,
          title: 'online_booking.title',
          pageTitle: 'online_booking.title'
        }
      },
      {
        path: 'advanced',
        component: AdvancedSettings,
        meta: {
          requiresAuth: true,
          title: 'online_booking.title',
          pageTitle: 'online_booking.advanced_title'
        }
      },
      {
        path: 'trackers',
        component: TrackersSettings,
        meta: {
          requiresAuth: true,
          title: 'online_booking.title',
          pageTitle: 'online_booking.trackers_title'
        }
      }
    ]
  }
]
